import { render, staticRenderFns } from "./appostgrp.vue?vue&type=template&id=2bae2324"
import script from "./appostgrp.vue?vue&type=script&lang=js"
export * from "./appostgrp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports